import { render, staticRenderFns } from "./SaleSearchBrowse.vue?vue&type=template&id=683ecb7a&scoped=true"
import script from "./SaleSearchBrowse.vue?vue&type=script&lang=ts"
export * from "./SaleSearchBrowse.vue?vue&type=script&lang=ts"
import style0 from "./SaleSearchBrowse.vue?vue&type=style&index=0&id=683ecb7a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683ecb7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('683ecb7a')) {
      api.createRecord('683ecb7a', component.options)
    } else {
      api.reload('683ecb7a', component.options)
    }
    module.hot.accept("./SaleSearchBrowse.vue?vue&type=template&id=683ecb7a&scoped=true", function () {
      api.rerender('683ecb7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/SaleSearchBrowse.vue"
export default component.exports